import { render } from "./DrugstoreGroupFormModal.vue?vue&type=template&id=5cab414e"
import script from "./DrugstoreGroupFormModal.vue?vue&type=script&lang=js"
export * from "./DrugstoreGroupFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__